<template>
	<div>
		<modal-check-link v-show="showLinkModal"
		                  @closeModal="showLinkModal = false"></modal-check-link>

		<div class="page-header navbar navbar-fixed-top">
			<div class="page-header-inner ">
				<alert></alert>

				<div style="float:left;background-color:white; padding:23px 15px 15px 45px;width:235px !important;"
				     id="bigLogo">
					<a href="/dashboard"><img src="/img/logo_abtool.svg"
						     width="195"
						     height="auto"
						     style="margin-top:-5px;margin-left:-25px;"></a>
					<a href="javascript:;"
					   class="menu-toggler responsive-toggler"
					   data-toggle="collapse"
					   data-target=".navbar-collapse">
						<span></span>
					</a>
				</div>

				<!-- logo end -->
				<ul class="nav navbar-nav navbar-left in">
					<li>
						<a class="menu-toggler sidebar-toggler"
						   id="resize"
						   name="resize">
							<i class="icon-menu"></i>
						</a>
					</li>
				</ul>

				<!-- start mobile menu -->
				<a href="javascript:;"
				   class="menu-toggler responsive-toggler"
				   data-toggle="collapse"
				   data-target=".navbar-collapse">
					<span></span>
				</a>
				<!-- end mobile menu -->
				<!-- start header menu -->
				<div class="top-menu">

					<ul class="nav navbar-nav pull-right">
						<!-- start language menu -->
						<li class="dropdown language-switch">
							<a v-if="userData.email != 'realestatepro@alfiobardolla.com'"
							   href="https://www.alfiobardolla.com"
							   class="btn btn-sm m-b-10 abtg__default-button "
							   style="position:relative; top:10px;">{{ $t('dashboard.torna_al_sito_ufficiale') }}</a>
							<a v-else
							   href="#"
							   @click="checkLogin({email:'supercoach@alfiobardolla.com', password: 'canestro40'})"
							   class="btn btn-sm m-b-10 abtg__default-button "
							   style="background-color:yellow; color: black;position:relative; top:10px;">
								 {{ $t('dashboard.torna_area_coach') }}
							</a>
						</li>
						<!-- end language menu -->
						<!-- start notification dropdown -->

						<li class="dropdown dropdown-user">
							<a href="javascript:;"
							   class="dropdown-toggle"
							   data-toggle="dropdown"
							   data-hover="dropdown"
							   data-close-others="true">
								<img alt=""
								     class="img-circle "
								     src="/img/team/user.jpg" />
								<span class="username username-hide-on-mobile abtg__header-link">{{userData.email}}</span>

								<i class="fas fa-angle-down"></i>
							</a>
							<ul class="dropdown-menu dropdown-menu-default">
								<li>
									<a href="#"
									   @click="showLinkModal = true">
										<i class="far fa-square" v-if="!userData.check_link_service"></i>
										<i v-else class="far fa-check-square"></i> Controllo link scaduti</a>
								</li>

								<li>
									<a href="#"
									   @click="logout()">
										<i class="icon-logout"></i> Log Out </a>
								</li>
							</ul>
						</li>
						<!-- end manage user dropdown -->

						<!-- trigger chatbar -->
						<li class="dropdown dropdown-quick-sidebar-toggler"
						    v-if="showChatBar">
							<a id="headerSettingButton"
							   class="mdl-button mdl-js-button mdl-button--icon pull-right"
							   data-upgraded=",MaterialButton">
								<i class="material-icons">more_vert</i>
							</a>
						</li>

					</ul>
				</div>
			</div>
		</div>
		<!--   <div style="margin-top:40px;" v-if="current === '/dashboard'">&nbsp;</div>-->
	</div>

</template>
<script>
	import { mapActions, mapState } from 'vuex'
	import { mixin } from '@/helpers/helper'
	import alert from '@/partials/top_alert'
	import modalCheckLink from '@/components/commons/modal_check_link'

	export default {
		mixins: [mixin],
		components: { alert, modalCheckLink },
		data: function() {
			return {
				isOpen: false,
				showChatBar: false,
				current: '',
				showLinkModal: false,
			}
		},

		computed: {
			...mapState('n_user', ['userData']),
		},
		created: function() {
			this.current = window.location.pathname
			this.getUserData()
			this.resize()
			this.checkRealTimeExpiring()
		},
		methods: {
			...mapActions('n_user', ['getUserData', 'logout', 'checkRealTimeExpiring', 'checkLogin']),

			resize: function() {
				if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < 1279) {
					this.isOpen = true
				}
			},
		},
	}
</script>
